// Prospect endpoint URLs for ManPowerService, split out of the (very large) service so
// the constant block stays browsable. Imported as a namespace (`MpEndpoints`) at the
// single call site of each. More endpoint groups can move here over time.

export const GET_PROSOECTLISTS = '/api/manpowers/prospects/getProspects';
export const GET_PROSPECT_DATA =
  '/api/manpowers/prospects/getProspectData/{:ID}';
export const GET_PROSPECT_CERT =
  '/api/manpowers/prospects/getProspectCert/{:ID}';
export const PUT_PROSPECT_CERT = '/api/manpowers/prospects/cert';
export const POST_PROSPECT_CERT = '/api/manpowers/prospects/cert';
export const GET_PROSPECT_RESUME =
  '/api/manpowers/prospects/getProspectResume/{:ID}';
export const PUT_PROSPECT_RESUME = '/api/manpowers/prospects/resume';
export const POST_PROSPECT_RESUME = '/api/manpowers/prospects/resume';
export const GET_PROSPECT_SAFETY =
  '/api/manpowers/prospects/getProspectSafety/{:ID}';
export const PUT_PROSPECT_SAFETY = '/api/manpowers/prospects/safety';
export const POST_PROSPECT_SAFETY = '/api/manpowers/prospects/safety';
export const GET_PROSPECT_FIT = '/api/manpowers/prospects/getProspectFit/{:ID}';
export const PUT_PROSPECT_FIT = '/api/manpowers/prospects/fit';
export const POST_PROSPECT_FIT = '/api/manpowers/prospects/fit';
